export default class FileUploaderComponent extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.prepararConfiguracion();
    }

    prepararConfiguracion() {
        this.uploadButton = this.querySelector("[data-action='file-upload']");
        this.resetButton = this.querySelector("[data-action='file-reset']");
        this.keepButton = this.querySelector("[data-action='file-keep']");
        this.input = this.querySelector("input[type='file']");
        this.deleteInput = this.querySelector("input[type='checkbox']");
        this.fileName = this.getAttribute("has-file");
        this.hasFile = this.hasAttribute("has-file") && this.getAttribute("has-file") != "";
        this.defaultMessage = "Dé click o arrastre su archivo"
        this.input.tabIndex = -1;

        if (this.hasFile) {
            this.uploadButton.setAttribute("disabled", "");
            this.keepButton.setAttribute("disabled", "");
            this.resetButton.removeAttribute("disabled");
            this.input.setAttribute("disabled", "");
            this.deleteInput.checked = false;
            this.uploadButton.innerText = this.fileName;
        } else {
            this.keepButton.setAttribute("disabled", "");
            this.resetButton.setAttribute("disabled", "");
        }

        this.resetInput = this.resetButtonClickCallback();
        this.keepPrevious = this.keepButtonClickCallback();
        this.callInput = this.uploadButtonClickCallback();
        this.changeFile = this.fileInputChangeCallback();
        this.dragFileOverUploadButton = this.uploadButtonDragOverCallback();
        this.stopDragOverUploadButton = this.uploadButtonDragLeaveCallback();
        this.uploadDroppedFile = this.uploadButtonDropCallback();

        this.uploadButton.addEventListener("click", this.callInput);
        this.resetButton.addEventListener("click", this.resetInput);
        this.keepButton.addEventListener("click", this.keepPrevious);
        this.input.addEventListener("change", this.changeFile);
        this.uploadButton.addEventListener("dragover", this.dragFileOverUploadButton);
        this.uploadButton.addEventListener("dragleave", this.stopDragOverUploadButton);
        this.uploadButton.addEventListener("drop", this.uploadDroppedFile);
    }

    resetButtonClickCallback() {
        return () => {
            this.deleteInput.checked = true;
            this.input.removeAttribute("disabled");
            this.input.value = null;

            this.uploadButton.removeAttribute("disabled");
            if (this.hasFile) {
                this.keepButton.removeAttribute("disabled");
            }

            this.uploadButton.innerText = this.defaultMessage;
            this.resetButton.setAttribute("disabled", "");
        }
    }

    keepButtonClickCallback() {
        return () => {
            if (!this.hasFile) {
                return;
            }

            this.input.setAttribute("disabled", "");
            this.input.value = null;
            this.deleteInput.checked = false;
            this.uploadButton.setAttribute("disabled", "");
            this.resetButton.removeAttribute("disabled");
            this.keepButton.setAttribute("disabled", "");
            this.uploadButton.innerText = (this.hasFile ? this.fileName : this.defaultMessage);
        }
    }

    uploadButtonClickCallback() {
        return () => {
            this.input.click();
        }
    }

    uploadButtonDragOverCallback() {
        return (event) => {
            event.preventDefault();
            if (!this.input.disabled) {
                this.uploadButton.classList.add("dragging");
            }
        }
    }

    uploadButtonDragLeaveCallback() {
        return () => {
            if (!this.input.disabled) {
                this.uploadButton.classList.remove("dragging");
            }
        }
    }

    uploadButtonDropCallback() {
        return (event) => {
            event.preventDefault();
            if (!this.input.disabled) {
                const files = event.dataTransfer.files;
                this.uploadButton.classList.remove("dragging");

                if (!!files && files.length > 0) {
                    const firstFile = files[0];
                    const dataTransfer = new DataTransfer();
                    dataTransfer.items.add(firstFile);
                    this.input.files = dataTransfer.files;
                    this.fileHandling();
                }
            }
        }
    }

    fileInputChangeCallback() {
        return () => {
            if (this.input.value != null) {
                this.fileHandling();
            } else {
                this.uploadButton.removeAttribute("disabled");
                this.resetButton.setAttribute("disabled", "");
            }
            if (this.hasFile) {
                this.keepButton.removeAttribute("disabled");
            }
        }
    }

    fileHandling() {
        const file = this.input.files[0];
        this.uploadButton.setAttribute("disabled", "");
        this.resetButton.removeAttribute("disabled");
        this.deleteInput.checked = false;
        this.uploadButton.innerText = "Nuevo archivo: " + file.name;
    }
}

